/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CollapsibleRow from './CollapsibleRow';
import { EntityType } from '../../../shared/submission/usePartiesService';

const useStyles = makeStyles(theme => ({
  header: {
    backgroundColor: theme.palette.elementBackground,
  },
}));

export default function DuplicateTable(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { duplicate } = props;
  const columnsByPartyType = {
    [EntityType.NATURAL_PERSON]: [{ head: t('parties.first-name'), key: 'firstName' }, { head: t('parties.last-name'), key: 'lastName' }, { head: t('parties.postal-code'), key: 'postalCode' }, { head: t('parties.address'), key: 'address' }],
    [EntityType.LEGAL_ENTITY]: [{ head: t('parties.company'), key: 'company' }, { head: t('parties.postal-code'), key: 'postalCode' }, { head: t('parties.address'), key: 'address' }],
  };

  const { party, duplicates } = duplicate;
  const columns = columnsByPartyType[party.partyType];
  return (
    <Table aria-label={t('contact.duplicate')}>
      <TableHead className={classes.header}>
        <TableRow>
          {columns?.map((col, i, { length }) => {
            const colSpan = length - 1 === i ? 3 : 1;
            return (
              <TableCell key={col.head} colSpan={colSpan}>
                {col.head}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {/* !!! decide how to handle multiple duplicates, for now we only concern ourselves with 1 */}
        <CollapsibleRow columns={columns} party={duplicates[0]} />
        <CollapsibleRow columns={columns} party={party} isNew />
      </TableBody>
    </Table>
  );
}
